import React, { useState } from "react";

export function Tabs({ children, tabStyle, activeClass, inactiveClass, activeTab, onTabChange }) {
  const [internalActiveTab, setInternalActiveTab] = useState(activeTab || 0);

  const handleTabClick = (index, value) => {
    setInternalActiveTab(value);
    onTabChange?.(value);
  };

  return (
    <div>
      {/* Tab Headers */}
      <div className={`overflow-x-auto whitespace-nowrap hide-scrollbar ${tabStyle}`}>
        {children.map((child, index) => {
          const value = child.props.value || index;
          return (
            <button
              key={value}
              className={`${activeTab === value ? activeClass : inactiveClass}`}
              onClick={() => handleTabClick(index, value)}
            >
              {child.props.title}
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <div>{children.find((child, index) => (child.props.value || index) === activeTab)}</div>
    </div>
  );
}

export function TabPanel({ children }) {
  return <div>{children}</div>;
}
